
import { createClient } from '@supabase/supabase-js';

// Using the Supabase project details
const supabaseUrl = 'https://gkhphsfrpculbftpjaft.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdraHBoc2ZycGN1bGJmdHBqYWZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYwMTA0MDcsImV4cCI6MjA2MTU4NjQwN30.GRtJlFshKW1p0khQi_Wxtlo65mHl975g_TdsV29qbIY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'proptpilot-auth-token',
    detectSessionInUrl: true,
    flowType: 'implicit'
  }

});

// Export a function to check and log current session (for debugging)
export const logSessionStatus = async () => {
  const { data, error } = await supabase.auth.getSession();
  return { data, error };
};
